import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/buttons/Button';
import Select from 'react-select';
import { customStyles } from '../../../utils/SelectStyles';
import { generalCreate } from '../../../API/api';

const statusOptions = [
  { label: 'Accepted', value: '3' },
  { label: 'Rejected', value: '4' }
];

export default function ApplicationStatusModal({ currentStatus, pId, setModal, setRefetchData, successMsg, warningMsg, setIsActive, post }: any) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [selectedStatus, setSelectedStatus] = useState<any>(null);

  const handleStatusChange = () => {
    setLoading(true);
    generalCreate({
      route: `/application-products/${pId}/update-status`,
      values: { status: selectedStatus.value }
    })
      .then((res) => {
        toast.success(successMsg);
        setRefetchData(new Date());
        setLoading(false);
        setModal(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    if (currentStatus) {
      setSelectedStatus(statusOptions.find((status: any) => status.value === currentStatus));
    }
  }, [currentStatus]);

  return (
    <div className="common-modal delete appStatus">
      <h4>{warningMsg}</h4>
      <div className="selectStatusWrapper">
        <Select
          value={selectedStatus}
          placeholder={t('selectStatus')}
          isSearchable={false}
          isClearable={false}
          isMulti={false}
          options={statusOptions}
          className={`select-drop-down `}
          noOptionsMessage={() => t('no_options')}
          classNamePrefix="react-select"
          styles={customStyles as any}
          onChange={(e: any) => setSelectedStatus(e)}
        />
      </div>
      <div className="buttons">
        <Button loading={loading} onClick={() => selectedStatus && handleStatusChange()} disabled={!selectedStatus}>
          <span className="bold">{t('confirm')}</span>
        </Button>
        <Button type={'submit'} onClick={() => setModal(false)}>
          {t('cancel')}
        </Button>
      </div>
    </div>
  );
}
